import React from 'react';

const ExperienceCard = ({ role, company, location, duration, description, technologies }) => (
  <div className="bg-white bg-opacity-10 rounded-2xl shadow-xl p-8 mb-10 hover:shadow-blue-500/30 transition duration-500">
    <h3 className="text-2xl font-semibold mb-2 text-blue-300">{role}</h3>
    <p className="font-bold text-blue-100">{company}, {location}</p>
    <p className="text-sm text-blue-200 mb-4">{duration}</p>
    <p className="text-gray-300 leading-relaxed mb-3">{description}</p>
    <p className="text-sm text-blue-200">Technologies: {technologies}</p>
  </div>
);

const Experience = () => {
  return (
    <section id="experience" className="py-20 bg-gradient-to-b from-gray-900 to-gray-900">
      <div className="container mx-auto px-6 max-w-4xl">
        <h2 className="text-3xl font-bold mb-12 text-center text-blue-300">
          Experience
        </h2>

        <ExperienceCard
          role="AI/ML Engineer Intern"
          company="Netcore Cloud"
          location="Bengaluru, India"
          duration="January 2026 – Present"
          description="Building an end-to-end data and machine learning pipeline for customer segmentation and targeting, ingesting data from Vertica, transforming and storing it in Amazon EFS, and performing feature engineering and data cleaning.
          Developing a clustering model for customer segmentation and orchestrated the workflow using Amazon Batch jobs for each pipeline stage."
          technologies="Python, SQL, FastAPI, Vertica, AWS (Amazon EFS, Amazon Batch), Pandas, Scikit-learn"
        />

        <ExperienceCard
          role="Machine Learning Intern"
          company="Crime Investigation Department- Karnataka"
          location="Bengaluru, India"
          duration="August 2025 – September 2025"
          description="Developed an AI-powered system to automatically analyze and categorize digital files for potential crime evidence."
          technologies="Python, FastAPI, OpenCV, YOLOv8, PyTorch"
        />

        <ExperienceCard
          role="Data Engineer Intern"
          company="Dover India"
          location="Bengaluru, India"
          duration="May 2025 – Present"
          description="Migrated and optimized legacy T-SQL Server stored procedures to scalable PySpark data pipelines for inventory and supply chain analytics. Enhanced ETL workflows and performance on distributed systems to support analytics and reporting needs using modern big data technologies."
          technologies="PySpark, SQL Server, Apache Spark, Distributed Systems"
        />

        <ExperienceCard
          role="Summer Intern"
          company="CSIR – Central Road Research Institute"
          location="New Delhi, India"
          duration="June 2024 – August 2024"
          description="Implemented a YOLOv8-based pedestrian and vehicle detection model to analyze accident-prone zones and support data-driven urban traffic optimization initiatives across New Delhi."
          technologies="OpenCV, YOLOv8, PyTorch"
        />
      </div>
    </section>
  );
};

export default Experience;